import { Box, Column, Row, Tooltip, Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { IPendingReview } from '~/domain/ShiftReview';
import { getShouldEnforcePermanentJobV2 } from '~/services/posthog/FeatureFlagUtils';
import { calculateAdjustedBreakTime, calculateAdjustedShiftTime, formatTime } from '../../utils';

interface IProps {
  it: IPendingReview;
}

export const AdjustmentDetailV2 = ({ it }: IProps) => {
  const hasAdjustment = it.hasAdjustShiftTime || it.hasAdjustBreakTime;

  return (
    <Column>
      {getShouldEnforcePermanentJobV2() && (
        <Box
          style={{
            alignSelf: 'flex-start',
            paddingBlock: 2,
            paddingInline: 10,
            marginBottom: 5,
            borderRadius: 8,
            backgroundColor: it?.isOnsiteInterview
              ? colors.favorites[50]
              : colors.primary[50],
          }}
        >
          <Typography size="caption" color={colors.neutral[500]}>
            {it?.isOnsiteInterview ? 'INTERVIEW' : 'SHIFT'}
          </Typography>
        </Box>
      )}

      <Row gap={1} style={{ flex: 1 }}>
        <Typography bold color={colors.neutral[500]} style={{ whiteSpace: 'nowrap' }}>
          {it.shift.localDate}
          {hasAdjustment ? ' •' : ''}
        </Typography>
        {hasAdjustment && (
          <Tooltip
            title={
              <Column>
                <Typography
                  color={colors.neutral[500]}
                  style={{
                    textDecoration: it.hasAdjustShiftTime ? 'line-through' : 'none',
                  }}
                >
                  {it.shift?.localStartTime} - {it.shift?.localEndTime}
                </Typography>
                <Typography
                  color={colors.neutral[500]}
                  style={{
                    textDecoration: it.hasAdjustBreakTime ? 'line-through' : 'none',
                  }}
                >
                  Meal Break: {formatTime(parseInt(it.shift?.breakTime, 10), false)}
                  {` (${it.shift?.isLunchBreakPaid ? 'Paid' : 'Unpaid'})`}
                </Typography>
              </Column>
            }
            placement="bottom"
          >
            <Typography
              style={{ textDecoration: 'underline', whiteSpace: 'nowrap', cursor: 'pointer' }}
              className="hover-bold"
            >
              Original Hours
            </Typography>
          </Tooltip>
        )}
      </Row>

      <Column>
        <Typography color={colors.neutral[500]}>
          {it.hasAdjustShiftTime
            ? `${it.adjustment?.localStartTime} - ${it.adjustment?.localEndTime}`
            : `${it.shift.localStartTime} - ${it.shift.localEndTime}`}
          {it.hasAdjustShiftTime && (
            <Typography as="span" bold color={colors.warning[500]} style={{ paddingLeft: 5 }}>
              {calculateAdjustedShiftTime(
                it.shift.localStartTime,
                it.shift.localEndTime,
                it.adjustment?.localStartTime,
                it.adjustment?.localEndTime,
              )}
            </Typography>
          )}
        </Typography>
      </Column>

      <Column>
        <Typography color={colors.neutral[500]}>
          Meal Break:{' '}
          {it.hasAdjustBreakTime
            ? formatTime(parseInt(it.adjustment?.breakTime || '', 10), false)
            : formatTime(parseInt(it.shift?.breakTime, 10), false)}
          {` (${it.shift?.isLunchBreakPaid ? 'Paid' : 'Unpaid'})`}
          {it.hasAdjustBreakTime && (
            <Typography as="span" bold color={colors.warning[500]} style={{ paddingLeft: 5 }}>
              {calculateAdjustedBreakTime(it.shift.breakTime, it.adjustment?.breakTime)}
            </Typography>
          )}
        </Typography>
      </Column>
    </Column>
  );
};
